import { HeaderBalanceComponent } from './header-balance.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        HeaderBalanceComponent
    ],
    exports: [
        HeaderBalanceComponent
    ],
    entryComponents: [],
})
export class HeaderBalanceModule { }
